import { styled } from "@mui/material/styles"
import type { SwitchProps } from "@mui/material/Switch"
import Switch from "@mui/material/Switch"

const IOSSwitchWarning = styled((props: SwitchProps) => (
  <Switch
    focusVisibleClassName=".Mui-focusVisible"
    disableRipple
    {...props}
    color="warning"
  />
))(({ theme }) => ({
  width: 38,
  height: 23,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        border: 0
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5
      }
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      border: "6px solid #fff"
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600]
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3
    }
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 18,
    height: 18,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10.641' height='10.641' viewBox='0 0 10.641 10.641'%3E%3Cpath id='bx-note' d='M9.459,0H1.182A1.183,1.183,0,0,0,0,1.182V9.459a1.183,1.183,0,0,0,1.182,1.182H5.912a.589.589,0,0,0,.418-.173l4.138-4.138a.59.59,0,0,0,.116-.173A.568.568,0,0,0,10.6,6.1a.586.586,0,0,0,.03-.153c0-.013.007-.024.007-.037V1.182A1.183,1.183,0,0,0,9.458,0ZM1.182,1.182H9.459V5.321H5.912a.591.591,0,0,0-.591.591V9.459H1.182ZM6.5,8.623V6.5h2.12Z' transform='translate(10.641 10.641) rotate(-180)' fill='%23edc461'/%3E%3C/svg%3E%0A"${")"}`
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500
    })
  }
}))

export default IOSSwitchWarning
